import * as React from 'react';
import { Input, Checkbox } from 'src/components/Shared/BsInput';
import { DestinationsAutocomplete } from 'lesamis-react-components';

export default class DestinationsActivities extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { values, setFieldValue, handleChange } = this.props;
    return (
      <div>
        <div className="form-group">
          <label>Destino</label>
          <DestinationsAutocomplete
            settings={{
              endpoint: 'autocompleteCities',
              multiple: false,
              emptyOnSelect: false,
            }}
            defaultSelected={values.data.hotels.destination ? [values.data.hotels.destination] : []}
            onSelected={(selected: any) => {
              if (!selected) {
                return;
              }

              setFieldValue('data.hotels.destination', { id: selected.id, name: selected.name });
            }}
            renderOption={(option: any, i: number) => {
              return (<div key={i}>{option.name}, {option.Country.name}</div>);
            }}
          />
        </div>
        <div className="form-group">
          <label>Categoria</label>
          <select
            name="data.hotels.category"
            className="form-control"
            onChange={handleChange}
            value={values.data.hotels.category}
          >
            <option value=""></option>
            <option value="1 estrellas">1 estrellas</option>
            <option value="2 estrellas">2 estrellas</option>
            <option value="3 estrellas">3 estrellas</option>
            <option value="4 estrellas">4 estrellas</option>
            <option value="5 estrellas">5 estrellas</option>
            <option value="Lujo">Lujo</option>
            <option value="Estancia">Estancia</option>
            <option value="Hostel">Hostel</option>
            <option value="ApartHotel 1">ApartHotel 1</option>
            <option value="ApartHotel 2">ApartHotel 2</option>
            <option value="ApartHotel 3">ApartHotel 3</option>
            <option value="ApartHotel 4">ApartHotel 4</option>
            <option value="ApartHotel 5">ApartHotel 5</option>
            <option value="Departamento">Departamento</option>
            <option value="Posada">Posada</option>
            <option value="Boutique">Boutique</option>
            <option value="Camping">Camping</option>
            <option value="Estancia 2">Estancia 2</option>
            <option value="Estancia 3">Estancia 3</option>
            <option value="Estancia 4">Estancia 4</option>
            <option value="Estancia 5*">Estancia 5*</option>
            <option value="Lodge">Lodge</option>
            <option value="Sin categoria">Sin categoria</option>
            <option value="Residencia">Residencia</option>
            <option value="Resort">Resort</option>
            <option value="Casa de alquiler">Casa de alquiler</option>
            <option value="Aparthotel">Aparthotel</option>
            <option value="Cabañas">Cabañas</option>
          </select>
        </div>
        <Input
          label="Hotel"
          value={values.data.hotels.hotel}
          name={'data.hotels.hotel'}
          onChange={this.props.handleChange}
          errors={this.props.errors}
        />
        <Checkbox
          name="data.hotels.recommended"
          label="Recomendado"
          onChange={handleChange}
          value={values.data.hotels.recommended}
          checked={values.data.hotels.recommended}
        />
        <div className="form-group">
          <label>Tipo</label>
          <select
            name="data.hotels.type"
            className="form-control"
            onChange={handleChange}
            value={values.data.hotels.type}
          >
            <option value=""></option>
            <option value="1">Opcion 1</option>
            <option value="2">Opcion 2</option>
            <option value="3">Opcion 3</option>
          </select>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Hotels.tsx